import { render, staticRenderFns } from "./ShortcutOverview.vue?vue&type=template&id=905b80e8&scoped=true"
import script from "./ShortcutOverview.vue?vue&type=script&lang=js"
export * from "./ShortcutOverview.vue?vue&type=script&lang=js"
import style0 from "./ShortcutOverview.vue?vue&type=style&index=0&id=905b80e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b80e8",
  null
  
)

export default component.exports